import React from 'react'

//images
import state from "../img/map.png";
import legend from "../img/Legende.png";


const Regulations=(props)=>{
    return(
        <section className="ftco-section contact-section ftco-no-pb" id="contact-section">
        <div className="container">
          <div className="row justify-content-center mb-5 pb-3">
            <div className="col-md-9 heading-section text-center ftco-animate fadeInUp ftco-animated">
              <h2 className="mb-4">Complete and simple overview of local Corona regulations</h2>
              <p>Press on your federal state to access the applicable local regulations</p>
            
            <div className="row d-md-flex no-gutters slider-text align-items-center justify-content-center">
              <img src={legend} alt="legend map"/>
               <img src={state} alt="state" useMap="#germany" />
               <map name="germany">
                <area coords="81,190,94,202,96,214,117,210,114,191,131,183,150,188,143,200,153,227,160,244,153,264,141,263,131,273,128,289,104,315,90,302,44,341,28,340,9,309,9,297,12,278,15,261,7,238,25,235,43,226,43,217,55,206,74,201"
                 shape="poly" alt="map" href="/nrw"/>
              </map>
           </div>
        </div>
        </div>
        </div>
      </section>
    )
}

export default Regulations